import { z } from "zod";

const UserSchema = z.object({
    id: z.number(),
    username: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    user_class: z.string(),
});

const CustomerSchema = z.object({
    id: z.number(),
    name: z.string(),
    location: z.string(),
    category: z.string(),
    notes: z.string(),
    number_deals: z.number(),
});

const SubsidiarySchema = z.object({
    id: z.number(),
    is_active: z.boolean(),
    name: z.string(),
    is_training: z.boolean(),
});

const ParentSchema = z.object({
    id: z.number(),
    type: z.string(),
    customer: CustomerSchema,
    name: z.string(),
    das: z.string(),
    subsidiary: SubsidiarySchema,
    short_name: z.string(),
    status: z.number(),
    sales: z.array(UserSchema),
    producers: z.array(UserSchema),
    analysis_lead: z.null(),
    production_lead: UserSchema.nullable(),
    budget: z.string(),
    billed_days: z.string(),
    contractor_budget: z.string(),
    billable_days: z.string(),
    mission_start_date: z.string().nullable(),
    mission_end_date: z.string().nullable(),
    agreement_leads: z.array(z.record(z.any())),
    parent: z.null(),
});

const MissionSchema = z.object({
    id: z.number(),
    status: z.number(),
    billable_days: z.string(),
    daily_rate: z.string(),
    notes: z.string().nullable(),
    projection_m1: z.string(),
    projection_m2: z.string(),
    projection_m3: z.string(),
    projection_q1: z.string(),
    projection_s1: z.string(),
    ressource: UserSchema,
    deal: z.number(),
});

export const getDealByIdSchema = z.object({
    id: z.number(),
    sales: z.array(
        z.object({
            ressource: UserSchema,
            percent: z.number(),
        })
    ),
    contractors: z.array(z.any()),
    analysis_lead: z.null(),
    production_lead: UserSchema.nullable(),
    customer: CustomerSchema,
    third_party_payers: z.array(CustomerSchema),
    producers: z.array(UserSchema),
    parent: ParentSchema.nullable(),
    origin: z.string(),
    das: z.string(),
    das_manager: UserSchema.nullable(),
    reference_owner_id: z.number().nullable(),
    loss_motive: z.string().nullable(),
    abandonment_motive: z.string().nullable(),
    subsidiary: z.string(),
    missions: z.array(MissionSchema),
    productions: z.array(z.any()),
    reference: z.any(),
    training: z.number().nullable(),
    satisfaction_survey_email: z.string().nullable(),
    billed_days: z.string(),
    agreement_leads: z.array(z.any()),
    type: z.string(),
    work: z.boolean(),
    indice: z.number(),
    rank: z.number().nullable(),
    name: z.string(),
    short_name: z.string(),
    status: z.number(),
    analysis_date: z.string().nullable(),
    chance: z.number(),
    est_remaining_production_days: z.string(),
    production_risk: z.number().nullable(),
    reception_date: z.string().nullable(),
    max_response_date: z.string().nullable(),
    response_date: z.string().nullable(),
    answer_date: z.string().nullable(),
    mission_start_date: z.string().nullable(),
    mission_end_date: z.string().nullable(),
    check_1_filing: z.number(),
    check_2_contract: z.number(),
    check_3_amendment: z.number(),
    check_4_subcontracting_contract: z.number(),
    check_5_factoring_contract: z.number(),
    budget: z.string(),
    budget_vat: z.string(),
    billable_days: z.string(),
    commission: z.string(),
    fixed_expense: z.boolean(),
    expense_budget: z.string(),
    procurement_cost: z.string(),
    billing_address: z.string(),
    notes: z.string().nullable(),
    satisfaction_survey_status: z.string(),
    min_budget: z.string(),
    max_budget: z.string(),
    agreement_budget: z.string(),
});

export type GetDealByIdSchemaType = z.infer<typeof getDealByIdSchema>;
